import React, {useState,useEffect,useContext,useRef} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso, AddItemToList,ArticleBarSearch,InpDataList} from "@gull";
import axios from 'axios'
import swal from "sweetalert2"
import { IsAuthContext } from 'app/App';

const useLoadInit = (props) => {
    const t = useTranslate();
    const [loadingZone,setLoadingZone] = useState(false)
    const [loadingSection,setLoadingSection] = useState(true)
    const [allZones,setAllZones] = useState([])
    const [allSections,setAllSections] = useState([])

    useEffect(function () {
        if (props.module != 'erp') {
            (async function() {
                props.setSectionArticleListe(props.section.id)
                setLoadingSection(false)
            })()
        }
        else {
            setAllSections(props.allSections)
            setLoadingSection(false)
        }
    }, [])

    useEffect(function () {
        if (props.sectionArticleListe!='') {
            (async function() {
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/zone/getall/"+props.sectionArticleListe
                ).then((response) => {
                    setAllZones(response.data.datas)
                    setLoadingZone(false)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    
                    swal.fire(t(messageError), "", "error");
                    setLoadingZone(false)
                })
            })()
        }
        else {
            setAllZones([])
        }
    }, [props.sectionArticleListe])

    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    
    return [allZones,allSections,loadingZone,setLoadingZone,loadingSection,loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput]
}

const EachDataFilter = (props) => {
    const [valueInput,setValueInput] = useState('')
    const inputRef = useRef('')
    const listRef = useRef('')
    const [datas,setDatas] = useState(props.binsList)

    const handleSearch = (e,declenchement) => {
        setValueInput(e.target.value);
        if(e.target.value.length>=declenchement){
            listRef.current.classList.remove("d-none");
            let ajour = props.binsList.filter((value)=>value.toString().toLowerCase().includes(e.target.value.toLowerCase()))
            setDatas(ajour)
        }
        else{
            listRef.current.classList.add("d-none");
        }
    }
    
    const handleClickFilter = (label) => {
        setValueInput(label)
        props.setBinsArticleListe(label)
        listRef.current.classList.add("d-none");
        setDatas([])     
    }

    return(
        <InpDataList
            placeholder="-- Select --"
            disabled={props.disabled}
            value={valueInput}
            onClick={handleClickFilter}
            onChange={handleSearch}
            datas={datas}
            declenchement={1}
            listRef={listRef}
            inputRef={inputRef}
            from='reorganizationStock'
        />
    )
}

const FormulaireAjoutArticleStockAdjustment = (props) => {
    const t = useTranslate();
    const [allZones,allSections,loadingZone,setLoadingZone,loadingSection,loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput] = useLoadInit(props)
    const [allBins,setAllBins] = useState([])
    const [validButton,setValidButton] = useState(false)
    const [validData,setValidData] = useState(false)

    const { authParam } = useContext(IsAuthContext);
    let actualShop = authParam.sections.find(value=>value.id==props.sectionArticleListe)

    // Zone par défaut à la sélection de section
    useEffect(function () {
        if(allZones.length!=0){
             
            let zoneCom = false
            if (actualShop && actualShop.advanceparams?.hasOwnProperty('reference_default_zone')) { // Si il y à une zone par défaut pour la section on la prend
                if (actualShop.advanceparams?.reference_default_zone==null) zoneCom = ''
                else zoneCom = allZones.find(zone => zone.id == actualShop.advanceparams?.reference_default_zone)
            }
            else { // Sinon par défaut on renseigne la zone sur la zone commerciale sur magasin
                zoneCom = allZones.find(zone => zone.type == 'commerciale')
            }

            props.setZoneArticleListe(zoneCom.id??'')
        }
        else {
            props.setZoneArticleListe('')
            props.setMemo('')
        }
    }, [allZones])

    // Contrôle bins à la sélection de la zone
    useEffect(function () {
        if(props.zoneArticleListe!='' && !!allZones.find(zone=>zone.id==props.zoneArticleListe)?.havebins){
            props.setHaveBins(true)
            getBins()
        }else {
            props.setHaveBins(false)
        }
        props.setBinsArticleListe('')
        props.setMemo('')
    }, [props.zoneArticleListe])

    // Contrôle validité des données avant envoi
    useEffect(function () {
        if (props.zoneArticleListe!='' && props.sectionArticleListe!='' && props.memo!='') {
            if (props.haveBins) {
                if (props.binsArticleListe!='') {
                    setValidData(true)
                }
            } else {
                setValidData(true)
            }
        } else {
            setValidData(false)
        }
    }, [props.zoneArticleListe,props.binsArticleListe,props.memo,props.articleListInfo])

    // Récupération des bins de la zone sélectionnée
    const getBins = async (name) =>{
        setLoadingZone(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/bins/getall/"+props.zoneArticleListe
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                messageError=messageError.replace('undefined','');
                swal.fire(t(messageError), "", "error");
            }else{
                setAllBins(response.data.datas)
                setLoadingZone(false)            
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoadingZone(false)
    }

    const handleResetConfirmation = () => {
        swal.fire({
            title: t('stockAdjustmentResetConfirmation'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('btnYes'),
            cancelButtonText: t('btnNo'),
        })
        .then((result) => {
            if (result.value) {
                props.handleResetForm()
            }
        });
    }

    const handleValidForm = () => {
        if (!props.showArticle) {
            props.setShowArticle(true)
        }
        else {
            handleResetConfirmation() 
        }
    }
    
    return (
        <CardPerso header={t('massStockAdjustment')}>
            <div className="row">
                <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                    <label>{t('shop')}</label>
                    {(props.module=='erp') ?
                        <>
                            <select disabled={(loadingSection || props.showArticle)} className='form-control' value={props.sectionArticleListe} onChange={(e)=>props.setSectionArticleListe(e.target.value)}>
                                <option value="">-- Select --</option>
                                {allSections && allSections.map(value=>{
                                    return(
                                        <option key={value.id} value={value.id}>{value.name}</option>
                                    )
                                })}
                            </select>
                            {loadingSection ? <div className="spinner-border spinner-border-sm" style={{position:'absolute', top:'55%'}}></div> : false}
                        </>
                    :
                        <select disabled={true} className='form-control' value={props.sectionArticleListe} onChange={(e)=>props.setSectionArticleListe(e.target.value)}>
                            <option value={props.section.id}>{props.section.name}</option>
                        </select>
                    }
                </div>
                <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                    <label>{t('zone')}</label>
                    <select disabled={(loadingZone || props.showArticle)} className='form-control' value={props.zoneArticleListe} onChange={(e)=>props.setZoneArticleListe(e.target.value)}>
                        <option value="">-- Select --</option>
                        {allZones && allZones.map(value=>{
                            return(
                                <option key={value.id} value={value.id}>{value.name}</option>
                            )
                        })}
                    </select>
                    {loadingZone ? <div className="spinner-border spinner-border-sm" style={{position:'absolute', top:'55%'}}></div> : false}
                </div>
                {(props.zoneArticleListe!=='' && props.haveBins) &&
                    <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                        <label>{t('binsNumber')}</label>
                        <EachDataFilter disabled={(loadingZone || props.showArticle)} binsList={allBins} binsArticleListe={props.binsArticleListe} setBinsArticleListe={props.setBinsArticleListe} />
                    </div>
                }
                {((props.zoneArticleListe!='' && !props.haveBins) || (props.zoneArticleListe!='' && props.haveBins && props.binsArticleListe)) &&
                    <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                        <label>Memo</label>
                        <textarea disabled={props.showArticle} className="form-control" onChange={(e)=>props.setMemo(e.target.value)}></textarea>
                    </div>
                }
                {/* <div className='col-12 col-md-6 col-lg-4 form-group position-relative'>
                    <label>{t('rh')}</label>
                    <input type="text" disabled={loadingZone} className='form-control' value={props.binsArticleListe} onChange={(e)=>props.setBinsArticleListe(e.target.value)} />
                </div> */}
            </div>
            <button
                className={"btn btn-sm "+(props.showArticle ? "btn-warning" : "btn-primary")}
                onClick={()=>handleValidForm()}
                disabled={validButton || !validData}
            >
                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : ((props.showArticle) ? t('btnReset') : t('btnValidate'))}
            </button>
        </CardPerso>
    );
}

export default FormulaireAjoutArticleStockAdjustment;


